let domain = window.location?.origin; 

export const isCibDomain = ()=> {
    if(domain === "https://cib.marketplace.rewardsby.com"){
        return true
    }
    return false
}